import React, {useEffect} from "react";
import {Modal} from "react-bootstrap";
import {useUpdateActionMutation} from "../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const ApproveActionModal = ({showApproveActionModal, onHide, details, tableRef}) => {
    const [
        updateAction, // This is the mutation trigger
        {
            isLoading: isUpdating,
            isSuccess: updatedSuccessfully,
        }, // This is the destructured mutation result
    ] = useUpdateActionMutation()

    /* Close Modal on Successful Update */
    useEffect(() => {
        if (updatedSuccessfully) {
            cogoToast.success("Action approved successfully")
            tableRef.current.refresh()
            onHide()
        }
    }, [updatedSuccessfully]);

    return (
        <Modal
            show={showApproveActionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Approve Action
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                <p>{`Are you sure you want to approve ${details?.action} action by ${details?.actionCreator}?`}</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    onClick={onHide}
                    disabled={isUpdating}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    onClick={() => updateAction({id: details?.id, status: "APPROVED"})}
                    disabled={isUpdating}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                >
                    Approve
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default ApproveActionModal;
